import { DirectiveOptions } from 'vue';
import { AccountModule } from '@/store/modules/account';

export const isOwnByName: DirectiveOptions = {
  componentUpdated(el, binding) {
    const { value } = binding;
    const accountName = AccountModule.userDetailInfo!.name;
    if (value && value instanceof Array && value.length > 0) {
      const userNames = value;
      const isOwn = userNames.some((name) => {
        return accountName === name;
      });
      if (!isOwn) {
        const parentNode = el.parentNode;
        parentNode?.removeChild(el);
      }
    } else {
      throw new Error('need roles! Like v-isOwn="[\'xxx\',\'xxxx\']"');
    }
  },
};
